import {
  Avatar,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  makeStyles,
  withWidth,
} from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import ReactHtmlParser from "react-html-parser";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import Img from "../../../components/Img";
import { formatCurrency } from "../../../components/Utils/Currency";
import { handleError } from "../../../components/Utils/Utils";
import History from "../../../History/History";
import PropertyService from "../../../Services/PropertyService";
import propertyStore from "../../../Store/PropertyStore";
import { showForm } from "./form";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

function DetailDialog(props) {
  const {
    title,
    width,
    dataProperty,
    access,
    handleShowForm,
    handleGetPropertyList,
  } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [expanded, setExpanded] = React.useState(false);
  const [propertyState, propertyActions] = propertyStore();
  const [data, setData] = React.useState("");

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenDialog = () => {};

  const handleUpdateData = () => {
    PropertyService.getDetail(data?.id)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const doEdit = () => {
    History.push("/property/edit/" + data?.id);
    setOpen(false);
  };

  const doDelete = () => {
    confirm(`Delete Property`, `Are you sure to delete this property ?`).then(
      async (onProcess) => {
        await propertyActions.deleted(data.id);
        setOpen(false);
        handleGetPropertyList(true);
        props.cancel();
      }
    );
  };

  React.useEffect(() => {
    setData(dataProperty);

    return () => {
      setData("");
    };
  }, []);

  return (
    <div>
      <Dialog
        maxWidth={width !== "xs" ? "sm" : false}
        fullScreen={width === "xs"}
        scroll="body"
        open={open}
        onClose={handleClose}
        onEnter={handleOpenDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">{title}</DialogTitle> */}
        <DialogContent style={{ padding: "0px" }}>
          <Grid container>
            <Grid item xs={12}>
              <div style={{ position: "relative", width: "auto" }}>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                  style={{
                    backgroundColor: "rgba(0,0,0,0.6)",
                    color: "#ffffff",
                    position: "absolute",
                    top: 25,
                    left: 25,
                  }}
                >
                  <ArrowBackRoundedIcon />
                </IconButton>
                <Img
                  src={data?.image_banner_url || ""}
                  alt={data?.name || ""}
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignitems: "center",
                  padding: "10px 20px",
                }}
              >
                {data?.logo?.square === "" ? (
                  <Avatar aria-label="recipe">
                    {data?.name?.trim().split(" ")[0].charAt(0)}
                  </Avatar>
                ) : (
                  <Avatar
                    alt={data?.name || ""}
                    aria-label="recipe"
                    src={data?.logo?.square}
                  >
                    {data?.name?.trim().split(" ")[0].charAt(0)}
                  </Avatar>
                )}
                <div style={{ display: "flex", alignItems: "center" }}>
                  {access.update && (
                    <IconButton
                      edge="start"
                      color="inherit"
                      onClick={doEdit}
                      aria-label="edit"
                      size="small"
                      style={{
                        backgroundColor: "#2196F3",
                        color: "#ffffff",
                        marginRight: 10,
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                  {access.delete && (
                    <IconButton
                      edge="start"
                      color="inherit"
                      onClick={doDelete}
                      aria-label="delete"
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} style={{ padding: "0px 20px" }}>
              <h2
                style={{
                  fontSize: 28,
                  fontWeight: "thin",
                  color: "#212121",
                  margin: 0,
                  lineHeight: 1,
                }}
              >
                {data?.name || ""}
              </h2>
              <p
                style={{
                  fontSize: 11,
                  fontWeight: "thin",
                  color: "#757575",
                  marginTop: 5,
                  marginBottom: 10,
                }}
              >
                {data?.address || ""}
              </p>
            </Grid>
            <Grid
              item
              xs={12}
              sm={8}
              md={8}
              lg={8}
              style={{ padding: "0px 20px" }}
            >
              <p style={{ fontSize: 14, color: "#212121" }}>
                {ReactHtmlParser(data?.about || "")}
              </p>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={4}
              style={{ padding: "0px 20px" }}
            >
              <p style={{ fontSize: 14, fontWeight: "thin", color: "#757575" }}>
                Customer Service Number
              </p>
              <p
                style={{
                  fontSize: 14,
                  color: "#212121",
                  overflowWrap: "break-word",
                }}
              >
                {data?.phone || "-"}
              </p>
              <p style={{ fontSize: 14, fontWeight: "thin", color: "#757575" }}>
                Email
              </p>
              <p
                style={{
                  fontSize: 14,
                  color: "#212121",
                  overflowWrap: "break-word",
                }}
              >
                {data?.email || "-"}
              </p>
              <p style={{ fontSize: 14, fontWeight: "thin", color: "#757575" }}>
                Website
              </p>
              <p
                style={{
                  fontSize: 14,
                  color: "#212121",
                  overflowWrap: "break-word",
                }}
              >
                {data?.website_url || "-"}
              </p>
              <p style={{ fontSize: 14, fontWeight: "thin", color: "#757575" }}>
                Lat/Lng
              </p>
              <p
                style={{
                  fontSize: 14,
                  color: "#212121",
                  overflowWrap: "break-word",
                }}
              >
                {data?.latitude || "-6.200000"},
                {data?.longitude || "106.816666"}
              </p>
              <p style={{ fontSize: 14, fontWeight: "thin", color: "#757575" }}>
                {data?.fee?.name || "Fee"}
              </p>
              <p
                style={{
                  fontSize: 14,
                  fontWeight: "bolder",
                  color: "#2196F3",
                  overflowWrap: "break-word",
                }}
              >
                {data?.fee?.percent > 0
                  ? formatCurrency(
                      process.env.REACT_APP_CURRENCY_CODE,
                      data?.fee?.percent,
                      true
                    ) + "%"
                  : data?.fee?.amount > 0
                  ? formatCurrency(
                      process.env.REACT_APP_CURRENCY_CODE,
                      data?.fee?.amount
                    )
                  : "-"}
              </p>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}

DetailDialog.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function showDetail(
  title,
  dataProperty,
  access,
  handleShowForm,
  handleGetPropertyList,
  options = {}
) {
  return createConfirmation(confirmable(withWidth()(DetailDialog)))({
    title,
    dataProperty,
    access,
    handleShowForm,
    handleGetPropertyList,
    ...options,
  });
}
